import { render } from "./SoilSampleIcon.vue?vue&type=template&id=5f9cd3f0"
import script from "./SoilSampleIcon.vue?vue&type=script&lang=js"
export * from "./SoilSampleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__